module.exports = __webpack_public_path__ + "img/3.8ea147ac.jpg";